import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { Close, LocalShipping } from '@mui/icons-material';
import { SendEquipmentFlyerForm } from './SendEquipmentFlyerForm';

interface SendEquipmentFlyerModalProps {
  equipmentId: string;
  open: boolean;
  onClose: () => void;
}

export const SendEquipmentFlyerModal: React.FC<SendEquipmentFlyerModalProps> = ({ equipmentId, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <LocalShipping /> Send Flyer
        </span>
        <IconButton aria-label="close" onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        <SendEquipmentFlyerForm equipmentId={equipmentId} onSuccess={onClose} />
      </DialogContent>
    </Dialog>
  );
};
